import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { SectionCard } from "shared/app/LeadsTableView/components/CreateLeadModal/SectionCard";
import { useFormController } from "shared/app/LeadsTableView/components/CreateLeadModal/useFormController";
import { DateInput, InputSize, Select, TextArea } from "shared/components";
import { LeadSource } from "views/leads-id/types";

export const DetailsSection = ({
  form
}: {
  form: ReturnType<typeof useFormController>;
}) => {
  const { data: sourceOptions } = useQuery({
    queryKey: ["LEAD_SOURCES"],
    queryFn: () => {
      return instance
        .get<{ items: LeadSource[] }>("/portal/v1/boom_crm/lead_sources")
        .then((res) => res.data)
        .then((data) =>
          data.items.map((source) => ({
            label: source.name,
            value: String(source.id)
          }))
        );
    }
  });

  return (
    <SectionCard title="Details">
      <div className="flex flex-col gap-6">
        {/* Row 1: Source (with icon) + Desired move-in (3 selects) */}
        <div
          className="grid gap-4 w-full max-w-[752px]"
          style={{ gridTemplateColumns: "repeat(2,minmax(0,1fr))" }}
        >
          <div className="w-full max-w-[368px] flex flex-col gap-1">
            <Select
              menuPosition="fixed"
              id="sourceEdit"
              size={InputSize.SM}
              label="Source"
              value={form.values.attribution.source}
              onChange={(e) =>
                form.setAttribution({
                  ...form.values.attribution,
                  source: e.target.value
                })
              }
              options={sourceOptions || []}
              className="!mb-0"
            />
          </div>
          <div className="w-full max-w-[368px] flex flex-col gap-1">
            <DateInput
              menuPosition="fixed"
              id="desiredMoveIn"
              label="[wip] Desired move-in"
              size={InputSize.SM}
              // value={desiredMoveIn}
              // onChange={(e: any) => {
              //   const v: string = e.target.value; // yyyy-mm-dd
              //   if (!v) return;
              //   setDesiredMoveIn(v);
              //   setField("moveInDate", v as any);
              // }}
            />
          </div>
        </div>
        {/* Message full width */}
        <div className="w-full max-w-[752px]">
          <TextArea
            id="message"
            label="Message"
            size={InputSize.BASE}
            placeholder="[wip] Message"
            // value={form.notes || ""}
            // onChange={(e) => setField("notes", e.target.value as any)}
            autoExpand
            className="text-sm font-medium !mb-0"
          />
        </div>
      </div>
    </SectionCard>
  );
};
